import { Image, ImageBackground, ImageStyle } from 'expo-image';
import { StyleProp, View } from 'react-native';

import { createMqStyles, useMqSelect } from '@fhs/ui';
import { region } from '@fhs-legacy/frontend/src/utils/environment';

import { CtaButton } from '../shared/cta-button';

export type ThanksgivingTurkeySubCardProps = {
  url: string;
};

export function ThanksgivingTurkeySubCard({ url }: ThanksgivingTurkeySubCardProps) {
  const mqStyles = useMqStyles();
  const backgroundSource = useMqSelect(
    {
      $gteDesktopLg: require('./thanksgiving-turkey-sub-card-background-desktop.webp'),
    },
    require('./thanksgiving-turkey-sub-card-background-tablet.webp')
  );
  const logoSource = require('./thanksgiving-turkey-sub-card-logo.webp');

  const altText = region() === 'US' ? 'New' : "It's back!";
  return (
    <ImageBackground
      alt={`${altText} Thanksgiving Turkey Sub`}
      source={backgroundSource}
      placeholder={{ thumbhash: 'LzkOI4h/tIZ+eFiFYJMHSGk' }}
      style={mqStyles.turkeySubBanner}
    >
      <View style={mqStyles.contentContainer}>
        <Image
          source={logoSource}
          alt="Thanksgiving Turkey Sub"
          placeholder={{ thumbhash: 'EcqGIYwnh5h/d3aHf3f4iFdmfol/Zzg' }}
          style={mqStyles.logo as StyleProp<ImageStyle>}
          contentFit="contain"
        />
        <CtaButton href={url} style={mqStyles.ctaContainer} />
      </View>
    </ImageBackground>
  );
}

const useMqStyles = createMqStyles({
  turkeySubBanner: {
    $base: {
      aspectRatio: 1024 / 505,
    },
    $gteDesktopLg: {
      aspectRatio: 1920 / 757,
    },
  },
  contentContainer: {
    $base: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      top: '10%',
      left: '5%',
    },
    $ltDesktopLg: {
      width: '43%',
    },
    $gteDesktopLg: {
      width: '48%',
    },
  },
  logo: {
    $base: {
      aspectRatio: 936 / 371,
      width: '100%',
    },
  },
  ctaContainer: {
    $base: {
      marginTop: 16,
      width: '35%',
    },
    $gteDesktopLg: {
      width: '25%',
    },
  },
});
